// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridContainer_Me7X1 {
  display: grid;
  gap: 12px;
}

.signInOption_ehSaY {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  background-color: var(--f1-background);
  width: 100%;
  border-radius: 6px;
  height: 30px;
}

.serverConfigContainer_jgBtR {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  column-gap: 24px;
}

.dropdownContainer_BlzMY {
  display: flex;
  flex-direction: column;
}

.dropdownContainer_BlzMY label {
  font-weight: 700;
}


`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/ModalsAddConnection/SMTPModalAddConnection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".gridContainer {\n  display: grid;\n  gap: 12px;\n}\n\n.signInOption {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 22px;\n  background-color: var(--f1-background);\n  width: 100%;\n  border-radius: 6px;\n  height: 30px;\n}\n\n.serverConfigContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  column-gap: 24px;\n}\n\n.dropdownContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.dropdownContainer label {\n  font-weight: 700;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `gridContainer_Me7X1`,
	"signInOption": `signInOption_ehSaY`,
	"serverConfigContainer": `serverConfigContainer_jgBtR`,
	"dropdownContainer": `dropdownContainer_BlzMY`
};
export default ___CSS_LOADER_EXPORT___;
